import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';

export const EMBEDDED_ROVO_SYSTEM_SPACE_OVERRIDE_QUERY_PARAM = 'allowRovoSystemSpace';

type LocationLike = {
	search?: string;
};

type IsEmbeddedRovoSystemSpaceAccessAllowedArgs = {
	isEditorPage: boolean;
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	location?: LocationLike | null;
};

export const isEmbeddedRovoSystemSpaceAccessAllowed = ({
	isEditorPage,
	location,
}: IsEmbeddedRovoSystemSpaceAccessAllowedArgs): boolean => {
	if (isEditorPage || !location) {
		return false;
	}

	const locationWithSearch: { search: string } = { search: location.search ?? '' };

	if (!isEmbeddedConfluence_DO_NOT_USE(locationWithSearch)) {
		return false;
	}

	return new URLSearchParams(locationWithSearch.search).has(
		EMBEDDED_ROVO_SYSTEM_SPACE_OVERRIDE_QUERY_PARAM,
	);
};
